// screen: old password-reset links (/reset/<token>, mailed until 2026-10-07) → the reset page (/password/reset?token=)
import * as React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

export const Route = createFileRoute('/reset/$token')({ component: ResetRedirect });

function ResetRedirect() {
  const { token } = Route.useParams();
  const navigate = useNavigate();
  React.useEffect(() => {
    void navigate({ to: '/password/reset', search: { token }, replace: true });
  }, [navigate, token]);
  return null;
}
